import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-zinc-900 border-t border-zinc-800">
      <div className="container mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto"
        >
          <div className="w-16 h-16 bg-zinc-950 border border-zinc-800 rounded-full flex items-center justify-center mx-auto mb-8 text-orange-500">
            <SafeIcon icon={FiIcons.FiHeadphones} className="w-8 h-8" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tighter text-white mb-6">
            Kontakt
          </h2>
          <p className="text-zinc-400 mb-8 text-lg">
            Für Anfragen, Kooperationen oder einfach einen Austausch melde dich bei mir.
          </p>

          <div className="bg-zinc-950 border border-zinc-800 p-6 md:p-8 rounded-sm mb-8 inline-block text-left w-full sm:w-auto">
            <div className="flex items-center gap-4 mb-4">
              <SafeIcon icon={FiIcons.FiMail} className="text-orange-500 w-6 h-6" />
              <div>
                <p className="text-xs text-zinc-500 uppercase font-bold tracking-wider">E-Mail</p>
                <a href="mailto:info@valerirudtmedia.de" className="text-white font-medium hover:text-orange-500 transition-colors text-lg">
                  info@valerirudtmedia.de
                </a>
              </div>
            </div>
          </div>

          <div className="bg-orange-500/10 border border-orange-500/20 text-orange-500 p-4 rounded-sm inline-flex items-center gap-3">
            <SafeIcon icon={FiIcons.FiZap} className="w-5 h-5 flex-shrink-0" />
            <p className="font-medium text-sm">
              Tipp: Am schnellsten erreichst du mich über eine direkte <a href="https://www.instagram.com/v.rudt/" target="_blank" rel="noreferrer" className="underline font-bold hover:text-orange-400">Instagram DM</a>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;